export default "/images/vendor/flag-icon-css/flags/4x3/hr.svg?89b8c8af46eef412f1cd0433ed3c7bc5";